/**
 * Canonical tool labels used across navigation, tiles, and tool-specific UIs.
 */
export const TOOL_LABELS = {
    timesheet: 'Stundennachweis',
    journal: 'Bautagebuch',
    leader: 'Kolonnenführer',
    rental: 'Vermietung',
    vehicleStatus: 'Fuhrpark',
    internalHandover: 'Interne Übergabe',
    files: 'Dateien',
    photos: 'Fotos',
    employee: 'Mitarbeiter'
};

/**
 * Returns the canonical display label for a tool key.
 *
 * @param {string} toolKey - Stable tool key.
 * @param {string} fallback - Fallback label when the key is unknown.
 * @returns {string}
 */
export function getToolLabel(toolKey, fallback = toolKey) {
    return TOOL_LABELS[toolKey] || fallback;
}
